import React from 'react'

const EmailSubscribeFormSuccess = () => {
  return (
    <div className='service-form__success alert alert-success my-4'>
        <h3 className='text-center'>Thanks!</h3>
    </div>
  )
}

export default EmailSubscribeFormSuccess